import $ from 'jquery';
import Slideshow from 'picnic/slideshow/views/Slideshow';


var
	SELECTOR_SLIDESHOW = '.slideshow:first'
;


class View extends Slideshow {

	constructor(options) {
		var
			el = $(options.el),
			max = Math.min(Math.max(el.find(SELECTOR_SLIDESHOW).children().length, 3), 4),
			settings = {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				responsive: [
					{
						breakpoint: 980,
						settings: {
							slidesToShow: max
						}
					},
					{
						breakpoint: 800,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 560,
						settings: {
							slidesToShow: 2
						}
					}
				],
				arrows: true,
				infinite: false
			}
		;

		super($.extend(true, {
			selector: SELECTOR_SLIDESHOW,
			settings: settings
		}, options));
	}

}

export default View;
